/**
 * Looks up a ride promotion from the map, trying from most specific to least specific.
 * Priority:
 *  1. start + end station match
 *  2. start station only
 *  3. end station only
 *  4. global (no station filter)
 */
export default function getPromotion({
  start_station_code,
  end_station_code,
  type,
  locale,
  ridePromotionsMap,
}) {
  if (!ridePromotionsMap) return null;

  const candidates = [
    `${start_station_code}-${end_station_code}-${type}-${locale}`,
    `${start_station_code}-*-${type}-${locale}`,
    `*-${end_station_code}-${type}-${locale}`,
    `*-*-${type}-${locale}`,
  ];

  const match = candidates.find((key) => ridePromotionsMap.has(key));
  return match ? ridePromotionsMap.get(match) : null;
}
